(() => {
	const accordionActive = (content) => {
		content.forEach((item) => {
			const { activeHeight } = item.dataset;

			item.style.maxHeight = activeHeight ? activeHeight : "100vh";
			item.style.removeProperty("padding-top");
			item.style.removeProperty("padding-bottom");
		});
	};
	const accordionDeActive = (content) => {
		content.forEach((item) => {
			item.style.maxHeight = "0";
			item.style.paddingTop = "0";
			item.style.paddingBottom = "0";
		});
	};

	// Accordion handling
	const accordion = document.querySelectorAll(".accordion");
	if (accordion) {
		accordion.forEach((accordion) => {
			const { activeType } = accordion.dataset;
			const input = accordion.querySelectorAll(".collapse");
			const content = accordion.querySelectorAll(".accordion-content");

			input.forEach((item) => {
				if (accordion.classList.contains("accordion-active")) {
					item.checked = true;
					accordionActive(content);
				} else {
					item.checked = false;
					accordionDeActive(content);
				}

				item.addEventListener("click", (e) => {
					document.querySelectorAll(".accordion").forEach((item) => {
						item.classList.remove("accordion-active");
					});
					if (!item.checked) {
						accordion.classList.remove("accordion-active");
					} else {
						accordion.classList.add("accordion-active");
					}

					if (activeType === "single") {
						item.classList.add("active");

						document
							.querySelectorAll(".accordion-content")
							.forEach((item) => {
								item.style.maxHeight = "0";
								item.style.paddingTop = "0";
								item.style.paddingBottom = "0";
							});

						document
							.querySelectorAll(".collapse")
							.forEach((item) => {
								if (
									item.classList.value ===
									e.target.classList.value
								) {
									if (item.checked) {
										item.checked = true;
									} else {
										item.checked = false;
									}
								} else {
									item.checked = false;
								}
							});
						item.classList.remove("active");
					}

					if (item.checked) {
						accordionActive(content);
					} else {
						accordionDeActive(content);
					}
				});
			});

			accordion.querySelectorAll(".collapse-label").forEach((item) => {
				const arrowSVG = item.querySelector(".collapse-label-icon");
				if (arrowSVG) {
					const { activeRotate, activeColor, deactiveColor } =
						arrowSVG.dataset;

					item.addEventListener("click", () => {
						if (arrowSVG.classList.contains(activeRotate)) {
							arrowSVG.classList.remove(activeRotate);
						} else {
							arrowSVG.classList.add(activeRotate);
						}
						if (activeColor && deactiveColor) {
							if (arrowSVG.classList.contains(activeRotate)) {
								arrowSVG.classList.remove(deactiveColor);
								arrowSVG.classList.add(activeColor);
							} else {
								arrowSVG.classList.remove(activeColor);
								arrowSVG.classList.add(deactiveColor);
							}
						}
					});
				}
			});
		});
	}

	// faqs accordion controller
	const active = ["border-b-2", "border-primary-500"];
	const deActive = ["border", "border-gray-300", "dark:border-gray-700"];
	const faqs = document.getElementById("faqs-accordion");
	if (faqs) {
		faqs.querySelectorAll(".accordion").forEach((element) => {
			console.log(element);
			if (element.classList.contains("accordion-active")) {
				element.classList.add(...active);
			} else {
				element.classList.add(...deActive);
			}
			element.addEventListener("click", () => {
				faqs.querySelectorAll(".accordion").forEach((element) => {
					if (element.classList.contains("accordion-active")) {
						element.classList.remove(...deActive);
						element.classList.add(...active);
					} else {
						element.classList.remove(...active);
						element.classList.add(...deActive);
					}
				});
			});
		});
	}
})();
